import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "./AnalyticalAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import AddEditAnalyticalNote from "../../../AddEditAnalyticalNote/AddEditAnalyticalNote";
import "../../AnalyticalNotesList.scss";

const AnalyticalAction = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditAnalyticalPopupVisible, setIsEditAnalyticalPopupVisible] =
    useState(false);
  const handleAnalyticalDisable = () => {
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/analyticalNotes/${data.id}`)
        .then(() => {
          onRefreshData(true);
        })
        .catch((error) => {
          onRefreshData(true);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editAnalytical = () => {
    setIsEditAnalyticalPopupVisible(true);
  };

  const closeSolutionEditPopup = () => {
    setIsEditAnalyticalPopupVisible(false);
  };
  return (
    <ButtonContainer>
      {data?.canEdit === 1 && (
        <div>
          <Image
            src={editIcon}
            title={t("EDIT")}
            onClick={editAnalytical}
            alt={t("EDIT")}
            className="analytical-notes-list__image-icon"
          />
          <Image
            src={deleteIcon}
            onClick={handleAnalyticalDisable}
            alt={t("DELETE")}
            title={t("DELETE")}
            className="analytical-notes-list__image-icon"
          />
          {isEditAnalyticalPopupVisible && (
            <AddEditAnalyticalNote
              id={data.id}
              title={t("EDIT_ANALYTICAL_NOTE")}
              onClose={closeSolutionEditPopup}
              isEditMode={isEditMode}
              isViewMode={isViewMode}
              updateRefeshStatus={updateRefeshStatus}
              siteId={data?.siteId}
            />
          )}
        </div>
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={t("ANALYTICAL_NOTE_CONFIRMATION_BOX_DELETE")}
          message={t("ANALYTICAL_NOTE_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

AnalyticalAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(AnalyticalAction);
